import React, { useContext, useEffect, useState } from "react";
import uiContext from "../context/ui/uiContext";
import BlogList from "./BlogList";
import styles from "../css/Modal.module.css";
import closebtn from "../image/times-solid.svg";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";

function EditBlog(props) {
  const history = useHistory();
  const [myBlogs, setMyBlogs] = useState(null);
  const dashContext = useContext(uiContext);
  const context = useContext(uiContext);

  const [currEdit, setCurrEdit] = useState({
    title: "",
    imglink: "",
    article: "",
    slug: "",
    category: "general",
  });

  const populateMyBlog = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}blog/myblogs`,
      {
        method: "GET",
        headers: {
          "auth-token": localStorage.getItem("auth-token"),
        },
      }
    );
    const data = await response.json();
    if (data.totalArticle === 0) {
      return setMyBlogs(0);
    }
    setMyBlogs(data);
    // console.log(myBlogs);
  };
  useEffect(async () => {
    await populateMyBlog();
    // eslint-disable-next-line
  }, []);

  const handleClick = () => {
    context.setEditModal((prev) => {
      return prev ? false : true;
    });
    dashContext.setDashNav(1);
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}blog/updatebyid?id=${context.toEdit.id}`,
        {
          method: "PUT",
          headers: {
            "auth-token": localStorage.getItem("auth-token"),
            "Content-Type":"application/json"
          },
          body: JSON.stringify(currEdit),
        }
      );
      const data = await response.json();
      console.log(data)
      if (!data.success) {
        return toast.error("Could Not delete Currently");
      }
      toast.info("Updated!!");
      context.setEditModal(false);
      history.push("/dashboard/myaccount");
    } catch (error) {}
  };

  const handleChange = (e) => {
    console.log(e.target.value);
    setCurrEdit((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  useEffect(async () => {
    if (context.editModal === true) {
      const getToEditDocument = async (id) => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}blog/getbyid?id=${id}`,
            {
              method: "GET",
              headers: {
                "auth-token": localStorage.getItem("auth-token"),
              },
            }
          );
          const data = await response.json();
          if (!data.success) {
            return;
          }
          setCurrEdit(() => {
            return {
              title: data.article.title,
              imglink: data.article.imglink,
              article: data.article.article,
              slug: data.article.slug,
              category: data.article.category,
            };
          });
        } catch (error) {}
      };
      await getToEditDocument(context.toEdit.id);
    }
    // eslint-disable-next-line
  }, [context.editModal]);
  return (
    <>
      <ToastContainer />
      {context.editModal ? (
        <div className={styles.module}>
          <img src={closebtn} onClick={handleClick} alt="close button" />
          <div className={styles.formdiv}>
            <div className={styles.formchild}>
              <label>Title</label>
              <input
                type="text"
                value={currEdit.title}
                name="title"
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.formchild}>
              <label>Category</label>
              <select
                name="category"
                onChange={handleChange}
                value={currEdit.category}
                required
              >
                <option value="general">General</option>
                <option value="technology">Technology</option>
                <option value="sports">Sports</option>
                <option value="health">Health</option>
                <option value="movies">Movies</option>
                <option value="bio">Bio</option>
              </select>
            </div>
            <div className={styles.formchild}>
              <label>Cover Img</label>
              <input
                type="text"
                name="imglink"
                onChange={handleChange}
                value={currEdit.imglink}
                required
              />
            </div>
            <div className={styles.formchild}>
              <label>Slug</label>
              <input
                type="text"
                name="slug"
                onChange={handleChange}
                value={currEdit.slug}
                required
              />
            </div>
            <div className={styles.formchild}>
              <label>Article</label>
              <textarea
                name="article"
                onChange={handleChange}
                value={currEdit.article}
                required
              ></textarea>
            </div>
            <div className={styles.formchild}>
              <button onClick={handleSubmit}>Submit</button>
            </div>
          </div>
        </div>
      ) : undefined}

      <div className="myblogsContainer">
        {myBlogs
          ? myBlogs.articles.map((e) => {
              return (
                <BlogList
                  title={e.title}
                  id={e._id}
                  key={e._id}
                  slug={e.slug}
                />
              );
            })
          : "No Blogs Currently"}
      </div>
    </>
  );
}

export default EditBlog;
